import { defineMessages } from "react-intl";

const messages = defineMessages({
    slogen: {
        id: "slogen",
    },
});

export default messages;